import React from "react";
import styled, { keyframes } from "styled-components";

// Replace this with the exact address you want visitors to use.
const EMAIL = "adampotocnikbusiness@gmail.com";
const INSTAGRAM_URL = "https://www.instagram.com/adampotocnikk";

export default function ContactPage() {
  return (
    <ContactMain>
      <ContactIntro>
        <Eyebrow>Let&apos;s work together</Eyebrow>
        <Title>
          Have an idea?
          <br />
          Let&apos;s make it real.
        </Title>
        <Description>
          For commissions, collaborations or just to say hello, reach out by
          email or send me a message on Instagram.
        </Description>
      </ContactIntro>

      <ContactLinks aria-label="Contact options">
        <ContactLink href={`mailto:${EMAIL}`}>
          <LinkMeta>
            <LinkLabel>Email</LinkLabel>
            <LinkValue>{EMAIL}</LinkValue>
          </LinkMeta>
          <Arrow aria-hidden="true">↗</Arrow>
        </ContactLink>

        <ContactLink href={INSTAGRAM_URL} target="_blank" rel="noreferrer">
          <LinkMeta>
            <LinkLabel>Instagram</LinkLabel>
            <LinkValue>@adampotocnikk</LinkValue>
          </LinkMeta>
          <Arrow aria-hidden="true">↗</Arrow>
        </ContactLink>
      </ContactLinks>

      <BackLink href="#sneakers">← Back to selected work</BackLink>
    </ContactMain>
  );
}

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ContactMain = styled.main`
  width: 100%;
  max-width: 1200px;
  min-height: calc(100dvh - 150px);
  margin: 0 auto;
  padding: clamp(72px, 10vw, 132px) 20px 72px;
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 0.9fr);
  align-items: end;
  gap: clamp(48px, 9vw, 120px);
  animation: ${fadeUp} 0.55s ease both;

  @media (max-width: 760px) {
    min-height: auto;
    grid-template-columns: 1fr;
    align-items: start;
    padding-top: 72px;
    gap: 48px;
  }
`;

const ContactIntro = styled.section`
  max-width: 680px;
`;

const Eyebrow = styled.p`
  margin: 0 0 22px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

const Title = styled.h1`
  margin: 0;
  color: var(--ink);
  font-family: "Instrument Serif", Georgia, serif;
  font-size: clamp(52px, 8vw, 104px);
  font-weight: 400;
  letter-spacing: -0.025em;
  line-height: 0.94;
`;

const Description = styled.p`
  max-width: 510px;
  margin: 32px 0 0;
  color: var(--muted);
  font-size: clamp(15px, 2vw, 18px);
  font-weight: 300;
  line-height: 1.65;
`;

const ContactLinks = styled.div`
  border-top: 1px solid var(--faint);
`;

const ContactLink = styled.a`
  min-height: 112px;
  padding: 24px 2px;
  border-bottom: 1px solid var(--faint);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  color: var(--ink);
  text-decoration: none;
  transition: padding 0.22s ease, border-color 0.22s ease;

  &:hover {
    padding-left: 10px;
    padding-right: 10px;
    border-color: var(--ink);
  }

  &:focus-visible {
    outline: 2px solid var(--ink);
    outline-offset: 4px;
  }
`;

const LinkMeta = styled.span`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LinkLabel = styled.span`
  color: var(--muted);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;

const LinkValue = styled.span`
  overflow-wrap: anywhere;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: clamp(24px, 3vw, 34px);
  font-weight: 400;
  letter-spacing: -0.015em;
`;

const Arrow = styled.span`
  flex-shrink: 0;
  font-size: 24px;
`;

const BackLink = styled.a`
  align-self: end;
  color: var(--muted);
  font-size: 12px;
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: var(--ink);
  }

  @media (min-width: 761px) {
    grid-column: 1 / -1;
    margin-top: 8px;
  }
`;
